// John Eldhose 20200810
const AcademyUser = (prop, data) => ({
  type: 'ACADEMY_USER',
  prop,
  data
});

export default AcademyUser;



// WEBPACK FOOTER //
// ./src/actions/AcademyUser.js